import React from 'react';

import Container from '@src/components/Shared/Container';
import InlineSVG from '@src/components/Shared/InlineSVG';
import NextImage from '@src/components/Shared/NextImage';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';

import { HeroValdProdPropTypes } from './HeroValdProd.types';

const HeroValdProd: React.FC<HeroValdProdPropTypes> = ({
  ctfData,
  className,
  id,
  children,
  logoClassName,
  imgClassName,
  introClassName,
  headerClassName,
}) => {
  return (
    <Container
      attr='vald-hero-prod-component'
      id={id}
      className={`relative mt-[6.5rem] flex flex-col md:min-h-[50rem] md:flex-row md:items-center md:justify-between ${className}`}
    >
      <header className={headerClassName}>
        <h1 className='invisible absolute'>{ctfData?.title}</h1>
        {ctfData?.logo?.url && (
          <InlineSVG
            className={`xsm:min-h-[5.3219rem] mt-[3rem] mb-[2.4rem] max-w-[27.6386rem] md:mt-[4.1rem] md:min-h-[4.9484rem] md:max-w-[25.7rem] lg:min-h-[6.9188rem] lg:max-w-[35.9302rem] 2xl:mb-[4.2rem] 2xl:min-h-[10.3906rem] 2xl:max-w-[53.96rem] ${logoClassName}`}
            src={ctfData?.logo?.url}
            renderAt={['desktop', 'tablet', 'mobile']}
          />
        )}

        <RenderBodyCopy
          entryId={ctfData?.sys?.id}
          className={introClassName}
          bodyCopy={ctfData?.bodyCopy?.json?.content}
        />
        {children}
      </header>

      <NextImage
        className={`${imgClassName}`}
        src={ctfData?.mediaPrimary?.url}
        alt={ctfData?.mediaPrimary?.description ?? '...'}
        width={ctfData?.mediaPrimary?.width}
        aspectRatio={ctfData?.mediaPrimary?.height}
        priority
      />
    </Container>
  );
};

export default HeroValdProd;
